export const resolveGameUrl = (baseUrl: string, gameLocale: string): string | null => {
  try {
    const url = new URL(baseUrl);

    if (url.protocol !== 'https:') {
      throw Error('The gameUrl is not https');
    }

    url.searchParams.set('telegram', 'true');
    url.searchParams.set('playdeck', 'true');
    url.searchParams.set('locale', gameLocale);

    return url.href + window.location.hash;
  } catch {
    const title = 'Invalid game url';
    const message =
      'Please check if the valid address of the game is specified in the admin panel. If you have any questions, please contact us.';

    alert(`${title}\n${message}`);

    return null;
  }
};
